import { Directive, inject } from '@angular/core';

import { TabBase } from '../components/TabPanel/tab-base';

@Directive({
  selector: 'button[tabPrevious]',
  host: {
    '(click)': 'tab.selectPrevious.emit()'
  }
})
export class TabPreviousButtonDirective {
  tab = inject(TabBase);
}